import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  CardImg,
  ButtonGroup,
  Button,
  Row,
  Modal,
  ModalHeader,
  InputGroupAddon,
  InputGroupText,
  Input,
  ModalBody,
  InputGroup,
  CustomInput
} from 'reactstrap';
import { ChromePicker } from 'react-color'
import {
  Separator,
  Colxx,
} from '../../../../../components/common/CustomBootstrap';

import {
  colorBlockStlye,
  editingStlyeWithoutBackGround,
  InputStlye,
  AvatarSizeStyle,
  setBackGroundColor,
} from '../style/DigitalAssistantStyle';

import avatars from '../data/avatarData';
//import Avatar from './Avatar';
import ImageGallery from '../../propinfo/gallery/index';
import { getGroupID } from '../../../../../helpers/AxiosAPI';
import { string } from 'prop-types';
import LanguageTabs from '../../propinfo/components/LanguageTabs/LanguageTabs';
export default function DigitalAssistant({
  isVoucher = false,
  botSettings,
  saveIntegration,
  integrationId,
  integrationLanguages,
  locale
}) {
  /** Avatar state */
  const [isSelected, setIsSelected] = useState({
    Jenni: false,
    Novi: false,
    Bob: false,
    Sarah: false,
    Wallis: false,
  });
  const [avatarLink, setAvatarLink] = useState('');
  const [avatarName, setAvatarName] = useState('');
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [assistantDetail, setAssistantDetail] = useState([]);
  /** other Digital Assistant state */
  // const [desktopAvatar, setDesktopAvatar] = useState('');
  // const [mobileAvatar, setMobileAvatar] = useState('');
  const [edit, setEdit] = useState(true);
  let [setting, setSetting] = useState(botSettings);
  const [error, setError] = useState(true);
  const [selectedLang, setSelectedLang] = useState(locale); // selected language
  let [iseditMode, setEditMode] = useState({
    'Header': false,
    'BotBot': false,
    'BotUser': false,
    'BotButton': false,
    'BotBackground': false,
    'HeaderText': false,
    'BotBotText': false,
    'BotUserText': false,
    'BotButtonText': false,
    'SendBoxText': false,
    'SendBoxBottomBorder': false,
    'HostedChatBotPageBody': false,
    'SendBoxButton': false,
    'SendBoxButtonHover': false,
    'SendBoxButtonFocus': false,
    'SendBoxPlaceHolder': false,
    'SendBoxBackground': false,
    'TimeStamp': false,
    'SuggestionBackground': false,
    'SuggestionText': false,
    'HeroButtonBackground': false,
    'HeroButtonText': false,
    'HeroButtonBackgroundHover': false,
    'HeroButtonTextHover': false,
    'LanguageDropdownBackground': false,
    'LanguageDropdownText': false,
    'CloseIcon': false,
    'CloseIconHover': false,
    'MinimizeIcon': false,
    'MinimizeIconHover': false,
    'SendIcon': false,
    'SendIconHover': false,
  });

  useEffect(() => {
    if (botSettings) {
      console.log('set', botSettings);
      setSetting(botSettings);
      // setDesktopAvatar(botSettings.sizes.desktopAvatar);
      // setMobileAvatar(botSettings.sizes.mobileAvatar);
      setAvatarName(botSettings.name);
      setAvatarLink(botSettings.urls.icon);
      setIsSelected({ ...avatars, [botSettings.name]: true });
      var assistantdata = botSettings.assistantDetails.filter(i => i.locale === locale);
      if (assistantdata.length > 0) {
        setAssistantDetail({
          name: assistantdata[0].name,
          title: assistantdata[0].title,
          subTitle: assistantdata[0].subTitle,
          locale: locale
        });
      } else {
        var assistantdataEn = botSettings.assistantDetails.filter(i => i.locale === "en");
        if (assistantdataEn.length > 0) {
          setAssistantDetail({
            name: assistantdataEn[0].name,
            title: assistantdataEn[0].title,
            subTitle: assistantdataEn[0].subTitle,
            locale: locale
          });
        }
      }
    }
  }, [botSettings]);

  useEffect(() => {
    if (setting) {
      setSetting({
        ...setting,
        // sizes: { desktopAvatar: desktopAvatar, mobileAvatar: mobileAvatar },
        urls: { ...setting.urls, icon: avatarLink },
      });
    }
  }, [avatarLink]);

  // const handleAvatarSizeChange = (e, type) => {
  //   const { value } = e.target;

  //   if (type === 'desktop') {
  //     setDesktopAvatar(value);
  //   } else if (type === 'mobile') {
  //     setMobileAvatar(value);
  //   }

  //   setSetting((prevSetting) => ({
  //     ...prevSetting,
  //     sizes: {
  //       ...prevSetting.sizes,
  //       [type === 'desktop' ? 'desktopAvatar' : 'mobileAvatar']: value,
  //     },
  //   }));
  // };


  const RedirectToDemo = () => {
    var url = `${process.env.REACT_APP_BOT_DEMO
      }?gid=${getGroupID()}&iid=${integrationId}`;
    window.open(url, '_blank');
  };

  const handleAssistantChange = (e) => {
    const value = e.target.value;
    setAssistantDetail({
      ...assistantDetail,
      [e.target.name]: value,
      locale: selectedLang,
    });
  };
  const handleCheckedBookingButton = (e) => {
    setSetting({
      ...setting,
      isBookingButtonHide: e.target.checked
    });
  }
  const handleCheckedHeaderHide = (e) => {
    setSetting({
      ...setting,
      isHeaderHide: e.target.checked
    });
  }
  const handleCheckedGreyscaleButton = (e) => {
    setSetting({ ...setting, isGreyScale: e.target.checked });
  }

  const handleChange = (e) => {
    const value = e.target.value;
    setSetting({
      ...setting,
      [e.target.name]: value,
    });
  };

  const SwitchLanguage = (lang) => {
    // Save current assistantDetail ONLY if name is not empty
    setSetting(prev => {
      let updated = prev.assistantDetails.filter(
        i => i.locale !== assistantDetail.locale
      );

      if (assistantDetail.name && assistantDetail.name.trim() !== "") {
        updated = [...updated, assistantDetail];
      }

      return {
        ...prev,
        assistantDetails: updated
      };
    });
    setSelectedLang(lang); //Switch selected language

    // Load existing or create blank detail
    const existing = setting.assistantDetails.find(i => i.locale === lang);

    if (existing) {
      setAssistantDetail(existing);
    } else {
      setAssistantDetail({
        name: "",
        title: "",
        subTitle: "",
        locale: lang
      });
    }
  };

  // const handleSave = () => {
  //   setEdit(!edit);
  //   var existingDetail = setting.assistantDetails.filter(i => i.locale !== locale);
  //   var assitantdata = [...existingDetail, assistantDetail];
  //   setting.assistantDetails = assitantdata;
  //   saveIntegration({ botSetting: setting });
  // };
  const handleSave = () => {
    setEdit(!edit);
    const filtered = setting.assistantDetails.filter(i => i.locale !== selectedLang); // Remove old entry for this language
    const updatedDetails = [...filtered, assistantDetail];    // Add / replace new record
    const updatedSetting = {
      ...setting,
      assistantDetails: updatedDetails
    };

    setSetting(updatedSetting);
    saveIntegration({ botSetting: updatedSetting });
  };

  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };
  const selectedImage = (image) => {
    setAvatarLink(image.src);
    setSetting({
      ...setting,
      name: image.caption,
    });
  };
  const SetClose = () => {
    setEditMode({
      'Header': false,
      'BotBot': false,
      'BotUser': false,
      'BotButton': false,
      'BotBackground': false,
      'HeaderText': false,
      'BotBotText': false,
      'BotUserText': false,
      'BotButtonText': false,
      'SendBoxText': false,
      'SendBoxBottomBorder': false,
      'HostedChatBotPageBody': false,
      'SendBoxButton': false,
      'SendBoxButtonHover': false,
      'SendBoxButtonFocus': false,
      'SendBoxPlaceHolder': false,
      'SendBoxBackground': false,
      'TimeStamp': false,
      'SuggestionBackground': false,
      'SuggestionText': false,
      'HeroButtonBackground': false,
      'HeroButtonText': false,
      'HeroButtonBackgroundHover': false,
      'HeroButtonTextHover': false,
      'LanguageDropdownBackground': false,
      'LanguageDropdownText': false,
      'CloseIcon': false,
      'CloseIconHover': false,
      'MinimizeIcon': false,
      'MinimizeIconHover': false,
      'SendIcon': false,
      'SendIconHover': false,
    });
  };
  const CloseColorBox = (event) => {
    if ((iseditMode.Header === true ||
      iseditMode.BotBot === true ||
      iseditMode.BotUser === true ||
      iseditMode.BotButton === true ||
      iseditMode.BotBackground === true ||
      iseditMode.HeaderText === true ||
      iseditMode.BotBotText === true ||
      iseditMode.BotUserText === true ||
      iseditMode.BotButtonText === true ||
      iseditMode.SendBoxText === true ||
      iseditMode.SendBoxBottomBorder === true ||
      iseditMode.HostedChatBotPageBody === true ||
      iseditMode.SendBoxButton === true ||
      iseditMode.SendBoxButtonHover === true ||
      iseditMode.SendBoxButtonFocus === true ||
      iseditMode.SendBoxPlaceHolder === true ||
      iseditMode.SendBoxBackground === true ||
      iseditMode.TimeStamp === true ||
      iseditMode.SuggestionBackground === true ||
      iseditMode.SuggestionText === true ||
      iseditMode.HeroButtonBackground === true ||
      iseditMode.HeroButtonText === true ||
      iseditMode.HeroButtonBackgroundHover === true ||
      iseditMode.HeroButtonTextHover === true ||
      iseditMode.LanguageDropdownBackground === true ||
      iseditMode.LanguageDropdownText === true ||
      iseditMode.CloseIcon === true ||
      iseditMode.CloseIconHover === true ||
      iseditMode.MinimizeIcon === true ||
      iseditMode.MinimizeIconHover === true ||
      iseditMode.SendIcon === true ||
      iseditMode.SendIconHover === true)) {
      SetClose();

    }
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={'avatar'}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  return (
    <Fragment>
      {botSettings ? (
        <Card>
          <CardBody name="bodyClick" onClick={(e) => { CloseColorBox(e); }}>
            <div className="text-center">
              <h6>Website Widget Appearance</h6>
              <p>Give your assistant a look and feel that reflects your brand.</p>
              <Separator className="mb-3" />
              <CardImg
                top
                src={avatarLink}
                alt="Card image cap"
                className="img-thumbnail border-0 rounded-circle list-thumbnail"
              />
              <div className="mb-1">
                <Button
                  color="success"
                  size="xs"
                  className="mt-1"
                  onClick={togglegallery}
                >
                  Browse Avatars
                </Button>
              </div>

              <div className="mb-1">
                <b>Assistant Name</b>
                <p>Give your digital assistant a name to personalize the experience, <br />or keep the default if you prefer.</p>
                <Row className='mt-2 item-center'>
                  <LanguageTabs
                    integrationLanguages={integrationLanguages}
                    selectedTab={selectedLang}
                    setLanguage={(e) => SwitchLanguage(e)}
                  ></LanguageTabs>
                </Row>
                <input

                  name="name"
                  style={{ ...InputStlye, marginTop: "0px" }}
                  value={assistantDetail.name || ""}
                  onChange={handleAssistantChange}
                />


              </div>
              {/* Avatar Size Inputs */}
              {/*  <div className="row mb-2 mt-2 text-center " style={{ margin: '0px 40px' }}>
                <div className=" text-center col-md-6 mb-1">
                  <b>Desktop Avatar Size</b>
                  <br />
                  <input
                    name="desktopAvatar"
                    type="number"
                    style={AvatarSizeStyle}
                    value={desktopAvatar}
                    min={50}
                    max={100}
                    onChange={(e) => handleAvatarSizeChange(e, 'desktop')}
                    placeholder=""
                  />
                </div>
                <div className=" text-center col-md-6 mb-1">
                  <b>Mobile Avatar Size</b>
                  <br />
                  <input
                    name="mobileAvatarSize"
                    type="number"
                    style={AvatarSizeStyle}
                    value={mobileAvatar}
                    min={50}
                    max={100}
                    onChange={(e) => handleAvatarSizeChange(e, 'mobile')}
                    placeholder=""
                  />
                </div>
              </div>
              */}
            </div>
            <div className="text-left mt-2">
              <div className="mb-1 text-center"><b>Colour Settings</b></div>
              <div style={{ padding: '0 5%' }}>


                <Row>
                  <Colxx xxs="12" className="text-left my-2"><h4><strong>Header</strong></h4></Colxx>
                  <Colxx xxs="6">
                    <div >
                      <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className='col-md-6 text-left' style={{
                          marginTop: '0.30rem'
                        }}><span className=''>Header background</span></div>
                        <div className='col-md-6'>
                          <InputGroup>
                            <Input
                              className=""
                              type="text"
                              onChange={(e) => {
                                let colours = setting.colours;
                                colours.header = e.target.value;
                                setSetting({ ...setting, colours: colours });
                              }}
                              value={setting.colours.header}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText onClick={() => {
                                setEditMode({ ...iseditMode, Header: !iseditMode.Header });
                              }
                              } className="color-square" style={setBackGroundColor(setting.colours.header)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                    {iseditMode.Header && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                        {/*        <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                          <div className='col-md-6 text-center' style={{
                            marginTop: '0.30rem'
                          }}><span className=''>Header background</span></div>
                          <div className='col-md-6'>
                            <InputGroup>
                              <Input
                                className=""
                                type="text"
                                value={setting.colours.header}
                              />
                              <InputGroupAddon addonType="append">
                                <InputGroupText className="color-square"style={setBackGroundColor(setting.colours.header)}></InputGroupText>
                              </InputGroupAddon>
                            </InputGroup>
                          </div>
                        </div> */}
                        <ChromePicker disableAlpha={true} className='ml-2'
                          style={{ width: '240px' }}
                          color={setting.colours.header}
                          onChangeComplete={(e) => {

                            if (edit) {
                              let colours = setting.colours;
                              colours.header = e.hex;
                              setSetting({ ...setting, colours: colours });
                            } else setError(true);
                          }
                          }
                        />
                      </div>
                    </div>}
                  </Colxx>
                  <Colxx xxs="6">           <div >
                    <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                      <div className=' col-md-6' style={{
                        marginTop: '0.30rem'
                      }}>Header Text</div>
                      < div className='col-md-6' >
                        <InputGroup className="">
                          <Input
                            className=""
                            type="text"
                            value={setting.colours.headerText}

                            onChange={(e) => {
                              let colours = setting.colours;
                              colours.headerText = e.target.value;
                              setSetting({ ...setting, colours: colours });
                            }}
                          />
                          <InputGroupAddon addonType="append">
                            <InputGroupText onClick={() => {
                              setEditMode({ ...iseditMode, HeaderText: !iseditMode.HeaderText });
                            }} className="color-square" style={setBackGroundColor(setting.colours.headerText)}></InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      </div>
                    </div>
                  </div>
                    {iseditMode.HeaderText && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                        {/*        <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                          <div className=' col-md-6 ' style={{
                            marginTop: '0.30rem'
                          }}>Header Text</div>
                          < div className='col-md-6' >
                            <InputGroup className="">
                              <Input
                                className=""
                                type="text"
                                value={setting.colours.headerText}

                              />
                              <InputGroupAddon addonType="append">
                                <InputGroupText className="color-square"style={setBackGroundColor(setting.colours.headerText)}></InputGroupText>
                              </InputGroupAddon>
                            </InputGroup>
                          </div>
                        </div> */}
                        <ChromePicker disableAlpha={true} className='ml-3 chrome-picker-extend' style={{ width: '180px' }}
                          color={setting.colours.headerText}
                          name="headerText"
                          onChange={(e) => {
                            if (edit) {
                              let colours = setting.colours;
                              colours.headerText = e.hex;
                              setSetting({ ...setting, colours: colours });
                            } else setError(true);
                          }
                          }
                        />
                      </div></div>}
                  </Colxx>


                  <Colxx xxs="6">
                    <div>
                      <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className=' col-md-6 ' style={{
                          marginTop: '0.30rem'
                        }}>   Close Icon</div>
                        < div className='col-md-6' >
                          <InputGroup className="">
                            <Input
                              className=""
                              type="text"
                              onChange={(e) => {
                                let colours = setting.colours;
                                colours.closeIcon = e.target.value;
                                setSetting({ ...setting, colours: colours });
                              }}
                              value={setting.colours.closeIcon}

                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText onClick={() => {
                                setEditMode({ ...iseditMode, CloseIcon: !iseditMode.CloseIcon });
                              }} className="color-square" style={setBackGroundColor(setting.colours.closeIcon)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>

                    {iseditMode.CloseIcon && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                        <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                          color={setting.colours.closeIcon}
                          name="closeIcon"
                          onChange={(e) => {

                            if (edit) {
                              let colours = setting.colours;
                              colours.closeIcon = e.hex;
                              setSetting({ ...setting, colours: colours });
                            } else setError(true);
                          }
                          }
                        />
                      </div>
                    </div>}
                  </Colxx>
                  <Colxx xxs="6">
                    <div >
                      <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className=' col-md-6 '> Close Icon Hover</div>
                        < div className='col-md-6' >
                          <InputGroup className="">
                            <Input
                              className=""
                              type="text"
                              value={setting.colours.closeIconHover}
                              onChange={(e) => {
                                let colours = setting.colours;
                                colours.closeIconHover = e.target.value;
                                setSetting({ ...setting, colours: colours });
                              }}

                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText onClick={() => {
                                setEditMode({ ...iseditMode, CloseIconHover: !iseditMode.CloseIconHover });
                              }} className="color-square" style={setBackGroundColor(setting.colours.closeIconHover)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                    {iseditMode.CloseIconHover && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                        <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                          color={setting.colours.closeIconHover}
                          name="closeIconHover"
                          onChange={(e) => {

                            if (edit) {
                              let colours = setting.colours;
                              colours.closeIconHover = e.hex;
                              setSetting({ ...setting, colours: colours });
                            } else setError(true);
                          }
                          }
                        />
                      </div>
                    </div>}
                  </Colxx>
                  <Colxx xxs="6">

                    <div>
                      <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className=' col-md-6' style={{
                          marginTop: '0.30rem'
                        }}>     Minimize Icon
                        </div>
                        < div className='col-md-6' >
                          <InputGroup className="">
                            <Input
                              className=""
                              type="text"
                              value={setting.colours.minimizeIcon}

                              onChange={(e) => {
                                let colours = setting.colours;
                                colours.minimizeIcon = e.target.value;
                                setSetting({ ...setting, colours: colours });
                              }}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText onClick={() => {
                                setEditMode({ ...iseditMode, MinimizeIcon: !iseditMode.MinimizeIcon });
                              }} className="color-square" style={setBackGroundColor(setting.colours.minimizeIcon)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                    {iseditMode.MinimizeIcon && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                        <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                          color={setting.colours.minimizeIcon}
                          name="minimizeIcon"
                          onChange={(e) => {

                            if (edit) {
                              let colours = setting.colours;
                              colours.minimizeIcon = e.hex;
                              setSetting({ ...setting, colours: colours });
                            } else setError(true);
                          }
                          }
                        />
                      </div>
                    </div>}
                  </Colxx>
                  <Colxx xxs="6">
                    <div>
                      <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className=' col-md-6 '>       Minimize Icon Hover</div>
                        < div className='col-md-6' >
                          <InputGroup className="">
                            <Input
                              className=""
                              type="text"
                              value={setting.colours.minimizeIconHover}

                              onChange={(e) => {
                                let colours = setting.colours;
                                colours.minimizeIconHover = e.target.value;
                                setSetting({ ...setting, colours: colours });
                              }}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText onClick={() => {
                                setEditMode({ ...iseditMode, MinimizeIconHover: !iseditMode.MinimizeIconHover });
                              }} className="color-square" style={setBackGroundColor(setting.colours.minimizeIconHover)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                    {iseditMode.MinimizeIconHover && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                        <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                          color={setting.colours.minimizeIconHover}
                          name="minimizeIconHover"
                          onChange={(e) => {

                            if (edit) {
                              let colours = setting.colours;
                              colours.minimizeIconHover = e.hex;
                              setSetting({ ...setting, colours: colours });
                            } else setError(true);
                          }
                          }
                        />
                      </div>
                    </div>}
                  </Colxx>
                  {/* <Colxx xxs="6">
                    <div >
                             <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className=' col-md-6 '>     Language Dropdown Background</div>
                        < div className='col-md-6' >
                          <InputGroup className="">
                            <Input
                              className=""
                              type="text"
                              value={setting.colours.languageDropdownBackground}

                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText onClick={() => {
                                setEditMode({ ...iseditMode, LanguageDropdownBackground: !iseditMode.LanguageDropdownBackground });
                              }} className="color-square" style={setBackGroundColor(setting.colours.languageDropdownBackground)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                    {iseditMode.LanguageDropdownBackground && <div className='parent-div'>
                         <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                        <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                          color={setting.colours.languageDropdownBackground}
                          name="languageDropdownBackground"
                          onChange={(e) => {
                            if (edit) {
                              let colours = setting.colours;
                              colours.languageDropdownBackground = e.hex;
                              setSetting({ ...setting, colours: colours });
                            } else setError(true);
                          }
                          }
                        />
                      </div>
                    </div>}
                  </Colxx>
                  <Colxx xxs="6">
                    <div >
                             <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className=' col-md-6 '>           Language Dropdown Text</div>
                        < div className='col-md-6' >
                          <InputGroup className="">
                            <Input
                              className=""
                              type="text"
                              value={setting.colours.languageDropdownText}

                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText onClick={() => {
                                setEditMode({ ...iseditMode, LanguageDropdownText: !iseditMode.LanguageDropdownText });
                              }} className="color-square" style={setBackGroundColor(setting.colours.languageDropdownText)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                    {iseditMode.LanguageDropdownText && <div className='parent-div'>
                         <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                        <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                          color={setting.colours.languageDropdownText}
                          name="languageDropdownText"
                          onChange={(e) => {
                            if (edit) {
                              let colours = setting.colours;
                              colours.languageDropdownText = e.hex;
                              setSetting({ ...setting, colours: colours });
                            } else setError(true);
                          }
                          }
                        />
                      </div>
                    </div>}
                  </Colxx> */}

                </Row>
                <Row>
                  <Colxx xxs="12" className="text-left my-2"><h4><strong>Conversation area</strong></h4></Colxx>
                  <Colxx xxs="6">
                    <div onClick={() => {
                      setEditMode({ ...iseditMode, BotBackground: !iseditMode.BotBackground });
                    }}>
                      <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className=' col-md-6 ' style={{
                          marginTop: '0.30rem'
                        }}>Background</div>
                        < div className='col-md-6' >
                          <InputGroup className="">
                            <Input
                              className=""
                              type="text"
                              onChange={(e) => {
                                let colours = setting.colours;
                                colours.botBackground = e.target.value;
                                setSetting({ ...setting, colours: colours });
                              }}
                              value={setting.colours.botBackground}

                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText className="color-square" onClick={() => {
                                setEditMode({ ...iseditMode, BotBackground: !iseditMode.BotBackground });
                              }} style={setBackGroundColor(setting.colours.botBackground)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                    {iseditMode.BotBackground && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                        <div className='row text-right'>
                          <ChromePicker disableAlpha={true} className='ml-3 chrome-picker-extend' style={{ width: '180px' }}
                            color={setting.colours.botBackground}
                            name="botBackground"
                            onChange={(e) => {

                              if (edit) {
                                let colours = setting.colours;
                                colours.botBackground = e.hex;
                                setSetting({ ...setting, colours: colours });
                              } else setError(true);
                            }
                            }
                          />
                        </div>
                      </div></div>}

                  </Colxx>
                  <Colxx xxs="6">
                  </Colxx>
                  <Colxx xxs="6">
                    <div>
                      <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className=' col-md-6 ' >
                          <span className=''>  Assistant Message Background</span></div>
                        <div className='col-md-6' >
                          <InputGroup className="">
                            <Input
                              className=""
                              type="text"
                              onChange={(e) => {
                                let colours = setting.colours;
                                colours.botBot = e.target.value;
                                setSetting({ ...setting, colours: colours });
                              }}
                              value={setting.colours.botBot}

                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText onClick={() => {
                                setEditMode({ ...iseditMode, BotBot: !iseditMode.BotBot });
                              }} className="color-square" style={setBackGroundColor(setting.colours.botBot)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>

                      </div>
                    </div>
                    {iseditMode.BotBot && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                        <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '240px' }}
                          color={setting.colours.botBot}
                          name="botBot"
                          onChange={(e) => {

                            if (edit) {
                              let colours = setting.colours;
                              colours.botBot = e.hex;
                              setSetting({ ...setting, colours: colours });
                            } else setError(true);


                          }}
                        />
                      </div>
                    </div>}
                  </Colxx>
                  <Colxx xxs="6">
                    <div>
                      <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className=' col-md-6 ' >  Assistant Response Text</div>
                        < div className='col-md-6' >
                          <InputGroup className="">
                            <Input
                              className=""
                              type="text"
                              onChange={(e) => {
                                let colours = setting.colours;
                                colours.botBotText = e.target.value;
                                setSetting({ ...setting, colours: colours });
                              }}
                              value={setting.colours.botBotText}

                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText onClick={() => {
                                setEditMode({ ...iseditMode, BotBotText: !iseditMode.BotBotText });
                              }} className="color-square" style={setBackGroundColor(setting.colours.botBotText)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                    {iseditMode.BotBotText && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                        <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                          color={setting.colours.botBotText}
                          name="botBotText"
                          onChange={(e) => {

                            if (edit) {
                              let colours = setting.colours;
                              colours.botBotText = e.hex;
                              setSetting({ ...setting, colours: colours });
                            } else setError(true);
                          }
                          }
                        />
                      </div> </div>}
                  </Colxx>
                  <Colxx xxs="6">
                    <div>
                      <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className=' col-md-6 ' >Visitor Message Background</div>
                        < div className='col-md-6' >
                          <InputGroup className="">
                            <Input
                              className=""
                              type="text"
                              value={setting.colours.botUser}

                              onChange={(e) => {
                                let colours = setting.colours;
                                colours.botUser = e.target.value;
                                setSetting({ ...setting, colours: colours });
                              }}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText className="color-square" onClick={() => {
                                setEditMode({ ...iseditMode, BotUser: !iseditMode.BotUser });
                              }} style={setBackGroundColor(setting.colours.botUser)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>

                      </div>
                    </div>
                    {iseditMode.BotUser && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                        <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '240px' }}
                          color={setting.colours.botUser}
                          name="botUser"
                          onChange={(e) => {

                            if (edit) {
                              let colours = setting.colours;
                              colours.botUser = e.hex;
                              setSetting({ ...setting, colours: colours });
                            } else setError(true);
                          }
                          }
                        />

                      </div>
                    </div>}
                  </Colxx>
                  <Colxx xxs="6">
                    <div >
                      <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className=' col-md-6 ' style={{
                          marginTop: '0.30rem'
                        }}>   Visitor Text</div>
                        < div className='col-md-6' >
                          <InputGroup className="">
                            <Input
                              className=""
                              type="text"
                              value={setting.colours.botUserText}

                              onChange={(e) => {
                                let colours = setting.colours;
                                colours.botUserText = e.target.value;
                                setSetting({ ...setting, colours: colours });
                              }}
                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText onClick={() => {
                                setEditMode({ ...iseditMode, BotUserText: !iseditMode.BotUserText });
                              }} className="color-square" style={setBackGroundColor(setting.colours.botUserText)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                    {iseditMode.BotUserText && <div className='parent-div'>
                      <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                        <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                          color={setting.colours.botUserText}
                          name="botUserText"
                          onChange={(e) => {

                            if (edit) {
                              let colours = setting.colours;
                              colours.botUserText = e.hex;
                              setSetting({ ...setting, colours: colours });
                            } else setError(true);
                          }
                          }
                        />
                      </div>   </div>}
                  </Colxx>
                  {/* <Colxx xxs="6" className="d-none">
                    <div onClick={() => {
                      setEditMode({ ...iseditMode, BotButtonText: !iseditMode.BotButtonText });
                    }}>
                             <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                        <div className=' col-md-6 ' >   Assistant Button Text (Not in Use)</div>
                        < div className='col-md-6' >
                          <InputGroup className="">
                            <Input
                              className=""
                              type="text"
                              value={setting.colours.botButtonText}

                            />
                            <InputGroupAddon addonType="append">
                              <InputGroupText className="color-square"style={setBackGroundColor(setting.colours.botButtonText)}></InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                    {iseditMode.BotButtonText && <div className='parent-div'>
                         <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                        <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                          color={setting.colours.botButtonText}
                          name="botButtonText"
                          onChange={(e) => {
                            if (edit) {
                              let colours = setting.colours;
                              colours.botButtonText = e.hex;
                              setSetting({ ...setting, colours: colours });
                            } else setError(true);
                          }
                          }
                        />
                      </div>
                    </div>}
                  </Colxx> */}
                  {!isVoucher && (
                    <Fragment>
                      {/* <Colxx xxs="6" className="d-none">
                        <div onClick={() => {
                          setEditMode({ ...iseditMode, BotButton: !iseditMode.BotButton });
                        }}>
                                 <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                            <div className=' col-md-6 '>  Assistant Button Fill (Not in Use)</div>
                            < div className='col-md-6' >
                              <InputGroup className="">
                                <Input
                                  className=""
                                  type="text"
                                  value={setting.colours.botButton}

                                />
                                <InputGroupAddon addonType="append">
                                  <InputGroupText className="color-square"style={setBackGroundColor(setting.colours.botButton)}></InputGroupText>
                                </InputGroupAddon>
                              </InputGroup>
                            </div>
                          </div>
                        </div>
                        {iseditMode.BotButton && <div className='parent-div'>
                             <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                            <div className='row text-right'>
                              <ChromePicker disableAlpha={true} className='ml-3 chrome-picker-extend' style={{ width: '180px' }}
                                color={setting.colours.botButton}
                                name="botButton"
                                onChange={(e) => {
                                  if (edit) {
                                    let colours = setting.colours;
                                    colours.botButton = e.hex;
                                    setSetting({ ...setting, colours: colours });
                                  } else setError(true);
                                }
                                }
                              />
                            </div>
                          </div></div>}
                      </Colxx>*/}

                      <Colxx xxs="6">
                        <div >
                          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                            <div className=' col-md-6 ' style={{
                              marginTop: '0.30rem'
                            }}> Suggestion Bubble Background</div>
                            < div className='col-md-6' >
                              <InputGroup className="">
                                <Input
                                  className=""
                                  type="text"
                                  value={setting.colours.suggestionBackground}

                                  onChange={(e) => {
                                    let colours = setting.colours;
                                    colours.suggestionBackground = e.target.value;
                                    setSetting({ ...setting, colours: colours });
                                  }}
                                />
                                <InputGroupAddon addonType="append">
                                  <InputGroupText className="color-square" onClick={() => {
                                    setEditMode({ ...iseditMode, SuggestionBackground: !iseditMode.SuggestionBackground });
                                  }} style={setBackGroundColor(setting.colours.suggestionBackground)}></InputGroupText>
                                </InputGroupAddon>
                              </InputGroup>
                            </div>
                          </div>
                        </div>
                        {iseditMode.SuggestionBackground && <div className='parent-div'>
                          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                            <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                              color={setting.colours.suggestionBackground}
                              name="suggestionBackground"
                              onChange={(e) => {

                                if (edit) {
                                  let colours = setting.colours;
                                  colours.suggestionBackground = e.hex;
                                  setSetting({ ...setting, colours: colours });
                                } else setError(true);
                              }
                              }
                            />
                          </div>
                        </div>}
                      </Colxx>
                      <Colxx xxs="6">
                        <div>
                          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                            <div className=' col-md-6 ' style={{
                              marginTop: '0.30rem'
                            }}>   Suggestion Bubble Text</div>
                            < div className='col-md-6' >
                              <InputGroup className="">
                                <Input
                                  className=""
                                  type="text"
                                  value={setting.colours.suggestionText}

                                  onChange={(e) => {
                                    let colours = setting.colours;
                                    colours.suggestionText = e.target.value;
                                    setSetting({ ...setting, colours: colours });
                                  }}
                                />
                                <InputGroupAddon addonType="append">
                                  <InputGroupText className="color-square" onClick={() => {
                                    setEditMode({ ...iseditMode, SuggestionText: !iseditMode.SuggestionText });
                                  }} style={setBackGroundColor(setting.colours.suggestionText)}></InputGroupText>
                                </InputGroupAddon>
                              </InputGroup>
                            </div>
                          </div>
                        </div>
                        {iseditMode.SuggestionText && <div className='parent-div'>
                          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                            <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                              color={setting.colours.suggestionText}
                              name="suggestionText"
                              onChange={(e) => {

                                if (edit) {
                                  let colours = setting.colours;
                                  colours.suggestionText = e.hex;
                                  setSetting({ ...setting, colours: colours });
                                } else setError(true);
                              }
                              }
                            />
                          </div>
                        </div>}
                      </Colxx>
                    </Fragment>
                  )}
                  {!isVoucher && (
                    <Fragment>
                      <Colxx xxs="6">
                        <div>
                          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                            <div className=' col-md-6 ' style={{
                              marginTop: '0.30rem'
                            }}>   Herocard Button Background</div>
                            < div className='col-md-6' >
                              <InputGroup className="">
                                <Input
                                  className=""
                                  type="text"
                                  value={setting.colours.heroButtonBackground}

                                  onChange={(e) => {
                                    let colours = setting.colours;
                                    colours.heroButtonBackground = e.target.value;
                                    setSetting({ ...setting, colours: colours });
                                  }}
                                />
                                <InputGroupAddon addonType="append">
                                  <InputGroupText className="color-square" onClick={() => {
                                    setEditMode({ ...iseditMode, HeroButtonBackground: !iseditMode.HeroButtonBackground });
                                  }} style={setBackGroundColor(setting.colours.heroButtonBackground)}></InputGroupText>
                                </InputGroupAddon>
                              </InputGroup>
                            </div>
                          </div>
                        </div>
                        {iseditMode.HeroButtonBackground && <div className='parent-div'>
                          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                            <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                              color={setting.colours.heroButtonBackground}
                              name="heroButtonBackground"
                              onChange={(e) => {

                                if (edit) {
                                  let colours = setting.colours;
                                  colours.heroButtonBackground = e.hex;
                                  setSetting({ ...setting, colours: colours });
                                } else setError(true);
                              }
                              }
                            />
                          </div>
                        </div>}
                      </Colxx>     <Colxx xxs="6">
                        <div >
                          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                            <div className=' col-md-6 ' style={{
                              marginTop: '0.30rem'
                            }}>    Herocard Button Text</div>
                            < div className='col-md-6' >
                              <InputGroup className="">
                                <Input
                                  className=""
                                  type="text"
                                  value={setting.colours.heroButtonText}

                                  onChange={(e) => {
                                    let colours = setting.colours;
                                    colours.heroButtonText = e.target.value;
                                    setSetting({ ...setting, colours: colours });
                                  }}
                                />
                                <InputGroupAddon addonType="append">
                                  <InputGroupText className="color-square" onClick={() => {
                                    setEditMode({ ...iseditMode, HeroButtonText: !iseditMode.HeroButtonText });
                                  }} style={setBackGroundColor(setting.colours.heroButtonText)}></InputGroupText>
                                </InputGroupAddon>
                              </InputGroup>
                            </div>
                          </div>
                        </div>
                        {iseditMode.HeroButtonText && <div className='parent-div'>
                          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                            <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                              color={setting.colours.heroButtonText}
                              name="heroButtonText"
                              onChange={(e) => {

                                if (edit) {
                                  let colours = setting.colours;
                                  colours.heroButtonText = e.hex;
                                  setSetting({ ...setting, colours: colours });
                                } else setError(true);
                              }
                              }
                            />
                          </div>
                        </div>}
                      </Colxx>     <Colxx xxs="6">
                        <div >
                          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                            <div className=' col-md-6 ' >  Herocard Button Hover Background</div>
                            < div className='col-md-6' >
                              <InputGroup className="">
                                <Input
                                  className=""
                                  type="text"
                                  value={setting.colours.heroButtonBackgroundHover}

                                  onChange={(e) => {
                                    let colours = setting.colours;
                                    colours.heroButtonBackgroundHover = e.target.value;
                                    setSetting({ ...setting, colours: colours });
                                  }}
                                />
                                <InputGroupAddon addonType="append">
                                  <InputGroupText className="color-square" onClick={() => {
                                    setEditMode({ ...iseditMode, HeroButtonBackgroundHover: !iseditMode.HeroButtonBackgroundHover });
                                  }} style={setBackGroundColor(setting.colours.heroButtonBackgroundHover)}></InputGroupText>
                                </InputGroupAddon>
                              </InputGroup>
                            </div>
                          </div>
                        </div>
                        {iseditMode.HeroButtonBackgroundHover && <div className='parent-div'>
                          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                            <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                              color={setting.colours.heroButtonBackgroundHover}
                              name="heroButtonBackgroundHover"
                              onChange={(e) => {

                                if (edit) {
                                  let colours = setting.colours;
                                  colours.heroButtonBackgroundHover = e.hex;
                                  setSetting({ ...setting, colours: colours });
                                } else setError(true);
                              }
                              }
                            />
                          </div>
                        </div>}
                      </Colxx>
                      <Colxx xxs="6">
                        <div >
                          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                            <div className=' col-md-6 ' style={{
                              marginTop: '0.30rem'
                            }}>  Herocard Button Hover Text</div>
                            < div className='col-md-6' >
                              <InputGroup className="">
                                <Input
                                  className=""
                                  type="text"
                                  value={setting.colours.heroButtonTextHover}

                                  onChange={(e) => {
                                    let colours = setting.colours;
                                    colours.heroButtonTextHover = e.target.value;
                                    setSetting({ ...setting, colours: colours });
                                  }}
                                />
                                <InputGroupAddon addonType="append">
                                  <InputGroupText className="color-square" onClick={() => {
                                    setEditMode({ ...iseditMode, HeroButtonTextHover: !iseditMode.HeroButtonTextHover });
                                  }} style={setBackGroundColor(setting.colours.heroButtonTextHover)}></InputGroupText>
                                </InputGroupAddon>
                              </InputGroup>
                            </div>
                          </div>
                        </div>
                        {iseditMode.HeroButtonTextHover && <div className='parent-div'>
                          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                            <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                              color={setting.colours.heroButtonTextHover}
                              name="heroButtonTextHover"
                              onChange={(e) => {

                                if (edit) {
                                  let colours = setting.colours;
                                  colours.heroButtonTextHover = e.hex;
                                  setSetting({ ...setting, colours: colours });
                                } else setError(true);
                              }
                              }
                            />
                          </div>
                        </div>}
                      </Colxx>
                    </Fragment>
                  )}
                </Row>
                <Row>
                  <Colxx xxs="12" className="text-left my-2"><h4><strong>Message box</strong></h4></Colxx>
                  {!isVoucher && (
                    <Fragment>
                      <Colxx xxs="6">
                        <div >
                          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                            <div className=' col-md-6 ' style={{
                              marginTop: '0.30rem'
                            }}>    Send Icon</div>
                            < div className='col-md-6' >
                              <InputGroup className="">
                                <Input
                                  className=""
                                  type="text"
                                  value={setting.colours.sendIcon}

                                  onChange={(e) => {
                                    let colours = setting.colours;
                                    colours.sendIcon = e.target.value;
                                    setSetting({ ...setting, colours: colours });
                                  }}
                                />
                                <InputGroupAddon addonType="append">
                                  <InputGroupText className="color-square" onClick={() => {
                                    setEditMode({ ...iseditMode, SendIcon: !iseditMode.SendIcon });
                                  }} style={setBackGroundColor(setting.colours.sendIcon)}></InputGroupText>
                                </InputGroupAddon>
                              </InputGroup>
                            </div>
                          </div>
                        </div>
                        {iseditMode.SendIcon && <div className='parent-div'>
                          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                            <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                              color={setting.colours.sendIcon}
                              name="sendIcon"
                              onChange={(e) => {

                                if (edit) {
                                  let colours = setting.colours;
                                  colours.sendIcon = e.hex;
                                  setSetting({ ...setting, colours: colours });
                                } else setError(true);
                              }
                              }
                            />
                          </div>
                        </div>}
                      </Colxx>

                      <Colxx xxs="6">
                        <div>
                          <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                            <div className=' col-md-6 ' style={{
                              marginTop: '0.30rem'
                            }}>  Send Icon Hover</div>
                            <div className='col-md-6' >
                              <InputGroup className="">
                                <Input
                                  className=""
                                  type="text"
                                  value={setting.colours.sendIconHover}

                                  onChange={(e) => {
                                    let colours = setting.colours;
                                    colours.sendIconHover = e.target.value;
                                    setSetting({ ...setting, colours: colours });
                                  }}
                                />
                                <InputGroupAddon addonType="append">
                                  <InputGroupText className="color-square" onClick={() => {
                                    setEditMode({ ...iseditMode, SendIconHover: !iseditMode.SendIconHover });
                                  }} style={setBackGroundColor(setting.colours.sendIconHover)}></InputGroupText>
                                </InputGroupAddon>
                              </InputGroup>
                            </div>
                          </div>
                        </div>
                        {iseditMode.SendIconHover && <div className='parent-div'>
                          <div className='cover' onClick={(e) => { e.stopPropagation(); }}>

                            <ChromePicker disableAlpha={true} className='ml-2' style={{ width: '180px' }}
                              color={setting.colours.sendIconHover}
                              name="sendIconHover"
                              onChange={(e) => {

                                if (edit) {
                                  let colours = setting.colours;
                                  colours.sendIconHover = e.hex;
                                  setSetting({ ...setting, colours: colours });
                                } else setError(true);
                              }
                              }
                            />

                          </div>
                        </div>}
                      </Colxx>


                    </Fragment>
                  )}
                </Row>
                <div className='row my-3'>
                  <div className='col-md-12'>
                    <CustomInput
                      key="isBookingButtonHide"
                      type="checkbox"
                      checked={setting.isBookingButtonHide}
                      onChange={(e) => handleCheckedBookingButton(e)}
                    ><span>Hide Booking Engine Button</span></CustomInput>
                  </div>
                </div>
                <div className='row my-3'>
                  <div className='col-md-12'>
                    <CustomInput
                      key="isGreyScale"
                      type="checkbox"
                      checked={setting.isGreyScale}
                      onChange={(e) => handleCheckedGreyscaleButton(e)}
                    ><span>Show Empowered by Myma.ai in Greyscale</span></CustomInput>
                  </div>
                </div>
                <div className='row my-3'>
                  <div className='col-md-12'>
                    <CustomInput
                      key="isHeaderHide"
                      type="checkbox"
                      checked={setting.isHeaderHide}
                      onChange={(e) => handleCheckedHeaderHide(e)}
                    ><span>Hide Header</span></CustomInput>
                  </div>
                </div>
              </div>
              <Separator className='mt-2 ' />
              <div className='text-center'>
                <div className="mb-2 " style={{ marginTop: '40px' }}>
                  <Button color="primary" size="xs" onClick={handleSave}>
                    Save
                  </Button>
                  <Button
                    size="xs"
                    color="secondary"
                    className='ml-2'
                    onClick={() => {
                      CloseColorBox();
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </CardBody>
        </Card >
      ) : null
      }
      {ImageGalleryButton()}

    </Fragment >
  );
}

